export const SOLUTIONS_URL = '/solutions';
